<template>
  <div class="storico-uoc-view">
    <h1>Storico UOC</h1>

    <p class="description">
      Questa sezione mostra lo storico delle operazioni UOC.
    </p>

    <table class="storico-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Descrizione</th>
          <th>Data</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in storico" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.descrizione }}</td>
          <td>{{ item.data }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const storico = ref([
  { id: 1, descrizione: 'Creazione UOC', data: '01/01/2026' },
  { id: 2, descrizione: 'Aggiornamento dati', data: '05/01/2026' },
  { id: 3, descrizione: 'Chiusura UOC', data: '10/01/2026' }
]);
</script>

<style scoped>
.storico-uoc-view {
  padding: 20px;
}

.description {
  margin-bottom: 16px;
  color: #555;
}

.storico-table {
  width: 100%;
  border-collapse: collapse;
}

.storico-table th,
.storico-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.storico-table th {
  background-color: #f4f4f4;
  text-align: left;
}
</style>
